import { AnaColumn } from "../forms-template.service";

export const giacenzeMovimentoPanel: AnaColumn[] = [


  {
    itemType: "group", caption: 'Rifiuto', class: '', visible: false, colSpan: "2",
    data: [


      /* {
        type: 'campo',
        dataField: "id",
        colWidth: null,
        colVisible: false,
        dataType: "",
        caption: "Codice",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
      }, */

      {
        type: 'campo',
        dataField: "eer",

        caption: 'EER',
        disableOnUpdate: true,
        hideOnEdit: true,
        allowEditing: false,
        colWidth: '70',
      },

      {
        type: 'campo',
        dataField: "idStatoFisico",
        caption: 'SF',
        colVisible: true,
        hideOnEdit: true,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '20',

      },
    ]
  },
  {
    itemType: "group", caption: 'R= messa in riserva,prima di op. R1..R12', class: 'carichi-in-r', visible: false, colSpan: "3",
    data: [
      /**R= messa in riserva,prima di op. R1..R12**/
      {
        type: 'campo',
        dataField: "tot_DaNostraLavorazione_R",
        dataType: "",
        format: '#,###.000',
        class: '',
        colVisible: true,
        caption: "Da Ns.Lavoraz.",
        hideOnEdit: true,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86',

      },
      {
        type: 'campo',
        dataField: "tot_AltriCarichi_R",
        colVisible: true,
        dataType: "",
        format: '#,###.000',
        class: '',
        caption: "Atri Carichi",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86'
      },
      {
        type: 'campo',
        dataField: "totale_R",
        colVisible: true,
        dataType: "",
        class: 'font-weight-bold',
        caption: "Totale R",
        format: '#,###.000',
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86'
      },
    ]
  },
  {
    itemType: "group", caption: 'D=deposito preliminare di op D1...D14', class: 'carichi-in-d', visible: true, colSpan: "3",
    data: [
      /**D=deposito preliminare di op D1...D14**/


      {
        type: 'campo',
        dataField: "tot_DaNostraLavorazione_D",
        colVisible: true,
        dataType: "",
        format: '#,###.000',
        class: '',
        caption: "Da Ns.Lavoraz.",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86',

      },

      {
        type: 'campo',
        dataField: "tot_AltriCarichi_D",
        colVisible: true,
        dataType: "",
        format: '#,###.000',
        class: '',
        caption: "Altri Carichi",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86'
      },

      {
        type: 'campo',
        dataField: "totale_D",
        colVisible: true,
        caption: "Totale D",
        format: '#,###.000',
        class: 'font-weight-bold',
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '56',

      },


    ]
  },
  {
    itemType: "group", caption: 'T = dep.Temporaneo', class: 'carichi-dt', visible: true, colSpan: "1",
    data: [
      /**T = deposito temporaneo**/
      {
        type: 'campo',
        dataField: "totale_DT",
        dataType: "",
        format: '#,###.000',
        class: 'font-weight-bold',
        caption: "Totale DT",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '100'
      },




    ]
  },
  {
    itemType: "dettaglio", groupDataField: 'dettaglioRifer', caption: 'Dettaglio riferimento', class: 'pippp', visible: true, colSpan: "1",
    data: [
      {
        type: 'campo',
        dataField: "eer",

        caption: 'EER',
        disableOnUpdate: true,
        hideOnEdit: true,
        allowEditing: false,
        colWidth: '70',
      },

      {
        type: 'campo',
        dataField: "idStatoFisico",
        caption: 'SF',
        colVisible: true,
        hideOnEdit: true,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '20',

      },

      {
        type: 'campo',
        dataField: "riferimentoEER",
        dataType: "",
        class: '',
        caption: "Rif.",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '80'
      },

      {
        type: 'campo',
        dataField: "tot_DaNostraLavorazione_R",
        dataType: "",
        format: '#,###.000',
        class: '',
        colVisible: true,
        caption: "Da Ns.Lavoraz.",
        hideOnEdit: true,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86',

      },
      {
        type: 'campo',
        dataField: "tot_AltriCarichi_R",
        colVisible: true,
        dataType: "",
        format: '#,###.000',
        class: '',
        caption: "Atri Carichi",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86'
      },
      {
        type: 'campo',
        dataField: "totale_R",
        colVisible: true,
        dataType: "",
        class: 'font-weight-bold',
        caption: "Totale R",
        format: '#,###.000',
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86'
      },

      {
        type: 'campo',
        dataField: "tot_DaNostraLavorazione_D",
        colVisible: true,
        dataType: "",
        format: '#,###.000',
        class: '',
        caption: "Da Ns.Lavoraz.",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86',

      },

      {
        type: 'campo',
        dataField: "tot_AltriCarichi_D",
        colVisible: true,
        dataType: "",
        format: '#,###.000',
        class: '',
        caption: "Altri Carichi",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '86'
      },

      {
        type: 'campo',
        dataField: "totale_D",
        colVisible: true,
        caption: "Totale D",
        format: '#,###.000',
        class: 'font-weight-bold',
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '56',

      },


      {
        type: 'campo',
        dataField: "totale_DT",
        dataType: "",
        format: '#,###.000',
        class: 'font-weight-bold',
        caption: "Totale DT",
        hideOnEdit: false,
        disableOnUpdate: true,
        allowEditing: false,
        colWidth: '50'
      },


    ]
  },
]
